import type {SidebarLink} from '@github-ui/saved-views'
import {SidebarListCollapsed} from './components/sidebar-list/SidebarList'
import type {DashboardTypes} from './types/dashboard-types'

interface DashboardSidebarCollapsedProps {
  dashboardType: DashboardTypes
  links: SidebarLink[]
  selectedLink: string
  onSelectLink: (linkItem: SidebarLink) => void
  savedViews: SidebarLink[]
  showSavedViews?: boolean
  onCreateView?: () => void
  generateLinkPath: (path: string | undefined, query?: string) => string
}

export function DashboardSidebarCollapsed({
  dashboardType,
  links,
  selectedLink,
  onSelectLink,
  showSavedViews = false,
  savedViews,
  onCreateView,
  generateLinkPath,
}: DashboardSidebarCollapsedProps) {
  const allLinks = showSavedViews ? [...links, ...savedViews] : links

  return (
    <>
      <SidebarListCollapsed
        dashboardType={dashboardType}
        links={allLinks}
        selectedLink={selectedLink}
        onSelectLink={onSelectLink}
        showCreateSavedViews={showSavedViews}
        onCreateView={onCreateView}
        generateLinkPath={generateLinkPath}
      />
    </>
  )
}
